/* ========= CONFIRM DIALOG ========= */
window.confirmDialog = function ({
  title,
  icon = 'warning',
  confirmText = 'Da',
  denyText = 'Ne'
}) {
  return Swal.fire({
    title,
    icon,
    showDenyButton: true,
    confirmButtonText: confirmText,
    denyButtonText: denyText,
    reverseButtons: true // Yes - right , No - left
  });
};

/* ========= TOAST ========= */
window.Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2500,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  }
});

window.toast = function (title, icon = 'success', timer = 2500) {
  if (!/[?.!]$/.test(title)) {
    title = title + '.';
  }

  return window.Toast.fire({
    title,
    icon, 
    timer
  });
};